import { getJson } from './baseApi'
import { getOffersDomain } from '../setup/configuration'

export const fetchOffer = id => {
	return getJson(`api/offers/${id}`)
}

export const fetchOffers = (partnerListingId) => {
	return getJson(getOffersDomain() + `/offers/search/${partnerListingId}`, { timeout: 180000, useApiDomain: false })
}